// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1y60N","header":"ReportDetails_header__Bdk2q","title":"ReportDetails_title__3SDmX","left":"ReportDetails_left__1VP0r"};